import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { findPageTitle } from '../../utils/menuUtils';

const HOME_TAB = { path: '/', title: '首頁', fixed: true };

export default function TabBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { permissions } = useAuth();
  const [tabs, setTabs] = useState([HOME_TAB]);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/') {
      return;
    }

    const title = findPageTitle(permissions, path);
    setTabs((prev) => {
      if (prev.some((tab) => tab.path === path)) {
        return prev;
      }
      return [...prev, { path, title, fixed: false }];
    });
  }, [location.pathname, permissions]);

  function closeTab(event, path) {
    event.stopPropagation();
    setTabs((prev) => {
      const next = prev.filter((tab) => tab.path !== path);
      if (location.pathname === path) {
        const fallback = next[next.length - 1] || HOME_TAB;
        navigate(fallback.path);
      }
      return next;
    });
  }

  return (
    <div className="admin-tabbar">
      {tabs.map((tab) => {
        const active = location.pathname === tab.path;
        return (
          <button
            key={tab.path}
            type="button"
            className={`admin-tab${active ? ' active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            {active && <span className="admin-tab-dot">●</span>}
            {tab.title}
            {!tab.fixed && (
              <span
                className="admin-tab-close"
                onClick={(e) => closeTab(e, tab.path)}
                role="presentation"
              >
                ×
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
